export default {
  cancelButton: 'Cancel',
  addIraButton: 'Add IRA',
  newIra: 'New IRA',
};
